<template>
  <div class="search-result-list">
    <ym-content-list v-if="type === searchResultContentType"
                     :list="contentList"
    />
    <ym-course-list v-else
                    class="search-result-list-content"
                    :list="list"
                    :lazy="false"
                    type="block"
    />
  </div>
</template>

<script>
  import CourseList from '@/components/ProductList/List';
  import ContentList from '@/pages/Search/components/SearchResultContentList';
  import { SEARCH_RESULT_COURSE_CONTENT_BLOCK_TYPE } from '@/utils/constant';

  export default {
    name: 'SearchResultList',
    components: {
      'ym-course-list': CourseList,
      'ym-content-list': ContentList,
    },
    data() {
      return {
        searchResultContentType: SEARCH_RESULT_COURSE_CONTENT_BLOCK_TYPE,
      };
    },
    props: {
      type: {
        type: String,
        required: true,
      },
      list: {
        type: Array,
        required: true,
      },
    },
    computed: {
      contentList() {
        const { list } = this;
        return list.map((item) => {
          item.mediaType = item.render.icon;
          return item;
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .search-result-list {
    &-content {
      padding-bottom: 0;
    }
  }
</style>
